import {gql} from 'apollo-angular';


export const categoryBaseFragment =  gql`
fragment categoryBase on Category {
  _id
  name
  shortName
  path
  cssClass
  level
  icon
  refName
  refPath
  adManagerKey
  rank
}
`;
